// 服务提供商，目地是解决数据源项目可以使用外界的提供的服务，解决数据源不需要知道后台服务器即可获取数据
const serviceProvider = function() {

    var pri = {
        dataService: undefined
    }

    var pub = {
        get dataService() {
            return pri.dataService
        },
        set dataService(value) {
            pri.dataService = value
        }
    }

    return pub;
}

var service = serviceProvider();

export default service;